const mLicenseModalUpgrade = {
  mLicenseModalUpgrade: {
    buttonPrimary: 'ENTENDIDO',

    messages: {
      administradores: 'Alcanzaste el límite máximo de administradores',
      alumnos: 'Alcanzaste el límite máximo de alumnos',
      instructores: 'Alcanzaste el límite máximo de instructores',
      link: 'actualizar plan',
      mapas: 'Alcanzaste el límite máximo de mapas',
      productos: 'Alcanzaste el límite máximo de productos',
      profesores: 'Alcanzaste el límite máximo de profesores',
      proyectos: 'Alcanzaste el límite máximo de cursos',
      puntosVenta: 'Alcanzaste el límite máximo de puntos de venta',
      upgrade: 'para aumentar las características de tu plan actual haz click en el siguiente enlace'
    },

    title: 'Atención'
  }
}

export default mLicenseModalUpgrade
